module.exports = __webpack_public_path__ + "f4d0d63506c9bc2a700acdc5d507dba1.svg";


//////////////////
// WEBPACK FOOTER
// ./components/dashboard/payments/accounts/green-alert.svg
// module id = 781
// module chunks = 0